import axios from './axios'

export const fetchProvinces = () => axios.get('/api/provinces', {})
export const fetchCities = (id) => axios.get(`/api/provinces/${id}/cities`)
export const fetchCountries = (p, c) => axios.get(`/api/provinces/${p}/cities/${c}/areas`)
